"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".mat-column-name[_ngcontent-%COMP%]{flex:0 0 40%}.mat-column-type[_ngcontent-%COMP%]{flex:0 0 130px}.mat-column-actions[_ngcontent-%COMP%]{flex:0 0 100px}"];
exports.styles = styles;
